import React from 'react';
import '../Style/Section05.css';

const App = () => {
  return (
    <div className="content-container" id='section05'>
      <section className="content02">
        <h1>Metanova Core Technologies</h1>
        <p className="paragraph-3 centered">
          <strong>Building the Foundation for the AI-Powered Metaverse</strong>
        </p>
        <p className="paragraph-4 centered">
          Our neural architecture doesn't just simulate worlds—it brings them to life. From NeuroAvatars with emotional
          intelligence to OmniVerse SDK for decentralized world-building, we're creating the essential tools for the next
          digital frontier. Whether it's AI-generated virtual economies, self-learning environments, or cross-platform
          identity protocols, our solutions ensure the metaverse isn't just for developers—it's for creators, businesses,
          and communities to own, shape, and thrive in.
        </p>
      </section>
    </div>
  );
};

export default App;
